<template lang="pug">
  div
    .search-container
      search-bar(
        :placeHolder="searchBarPlaceholder",
        :hasCleanButton="true",
        @search="(searchValue) => handleSearch(searchValue)"
      )
    app-credenciar(
      :showModalCredenciar="showModalCredenciar",
      @closeModal="showModalCredenciar = false",
      @refresh="handleSearch(filtro.campoSimples, paginaAtual)"
      :protocolo="protocolo",
      :numeroProcesso="numeroProcesso"
    )
    el-row(:gutter="20")
      el-col(:span="24")
        h2.custom-label Listagem de possíveis credenciados
      el-table.table(
        :data="processos"
        @sort-change="sort"
        v-loading="loading"
      )
        template(slot="empty") Não foram encontrados processos com os dados informados
        el-table-column(
          label="Nº do Processo",
          header-align="center",
          align="center"
          sortable="custom"
          prop="numeroProcesso"
        )
        el-table-column(
          label="Interessado",
          header-align="center",
          align="center"
          sortable="custom"
          prop="nomeRazaoSocialInteressado"
        )
        el-table-column(
          label="Status",
          header-align="center",
          align="center"
          sortable="custom"
          prop="status"
        )
        el-table-column(
          label="Setor",
          header-align="center",
          align="center"
          sortable="custom"
          prop="setor"
        )
        el-table-column(
          label="Tipo",
          header-align="center",
          align="center"
          sortable="custom"
          prop="tipo"
        )
        el-table-column(
        label="Ações",
        align="center",
        align-header="center"
        width="150"
        )
          template(slot-scope="scope")
            el-dropdown.botao-acoes(trigger="click", size="small")
              el-button(type="primary", size="mini")
                | Ações
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot="dropdown")
                el-dropdown-item
                  div(
                    @click="visualizar(scope.row)"
                  )
                    i.fa(
                      class="fa-eye"
                    )
                    | &nbsp Visualizar Processo
                el-dropdown-item
                  div(
                    @click="openCredenciar(scope.row)"
                  )
                    i.fa(
                      class="fa-address-book"
                    )
                    | &nbsp Credenciar

    Pagination(:total="quantidadeResultados" :pagina="paginaAtual" :tamanhoPagina="tamanhoPagina" @changePage="changePage")
</template>

<script>
import { SearchBar, Table, Pagination } from 'sicarf-components'
import { findProcessosByFiltro } from '@/services/credenciadoService';
import { getTipoByUser } from '@/services/editalService';
import AppCredenciar from '@/components/AppCredenciar'

export default {
  components: {
    SearchBar,
    Table,
    Pagination,
    AppCredenciar
  },
  data () {
    return {
      isModalVisible: false,
      filtro: {},
      filtroSort: {},
      editalVigente: null,
      searchBarPlaceholder: 'Informe o número do processo, protocolo do processo, cpf do interessado ou nome do interessado',
      processos: [],
      quantidadeResultados: 0,
      paginaAtual: 0,
      tamanhoPagina: 15,
      loading: false,
      tipoEdital: '',
      columnsGeomensor: [
        { key: 'pessoa.pessoaFisica.nome', label: 'Nome', order: 'custom', codigo: 'NOME' },
        { key: 'pessoa.pessoaFisica.cpf', label: 'CPF', codigo: 'CPF' },
        { key: 'codigoIncra', label: 'Código do INCRA', codigo: 'CODIGO_INCRA' },
        { key: 'codigoCrea', label: 'Registro no conselho', codigo: 'REGISTRO_CONSELHO' },
        { key: 'pessoa.email', label: 'E-mail', codigo: 'EMAIL' },
        { key: 'responsavel.pessoa.pessoaFisica.nome', label: 'Responsável pelo credenciamento', codigo: 'RESPONSAVEL' }
      ],
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      protocolo: null,
      showModalVisualizarProcesso: false,
      showModalCredenciar: false
    }
  },
  async mounted () {
    this.loading = true;
    this.tipoEdital = await getTipoByUser();
    this.handleSearch();
  },
  methods: {
    async handleSearch (searchValue, pagina = 0) {
      this.loading = true;
      this.filtro = {}
      this.filtro.campoSimples = searchValue || '';
      this.filtro.pagina = pagina;
      this.filtro.ordem = this.filtroSort.ordem;
      this.filtro.ordemDirecao = this.filtroSort.ordemDirecao;
      const resp = await findProcessosByFiltro(this.filtro);
      this.processos = resp.processos.content;
      this.quantidadeResultados = resp.processos.totalElements;
      this.loading = false;
    },
    changePage (newPage) {
      this.paginaAtual = newPage - 1;
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual);
    },
    sort (item) {
      this.filtroSort.ordem = item.prop;
      if (item.order === 'ascending') {
        this.filtroSort.ordemDirecao = 'ASC';
      } else {
        this.filtroSort.ordemDirecao = 'DESC';
      }
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual);
    },
    visualizar (item) {
      window.open(`${process.env.VUE_APP_SICARF_URL}?protocolo=${item.numeroProtocolo}/#/visualizarProcesso`, `Visualizar processo ${item.numeroProcesso}`, 'height=500,width=800,top=25%, left=50%')
    },
    openCredenciar(item) {
      this.showModalCredenciar = true
      this.numeroProcesso = item.numeroProcesso
      this.protocolo = item.numeroProtocolo
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.custom-label{
    font-size: $font-size-medium;
    text-align: left;
    color: #606266;
  }
.marginLeft {
  margin-left: 5px;
}
.cadastrar {
  float: right;
}
.marginRight {
  margin-right: 10px;
}
.groups-title {
  padding-left: 10px;
  text-align: start;
  display: flex;
}
.text-center {
  text-align: center;
}
.redColor {
  color: $error;
}
.greenColor {
  color: $color-primary;
}
.yellowColor {
  color: $warning;
}
.not-found-text {
  color: $font-color;
}
.textDropdown {
  margin-left: 5px;
}

.export-button-container {
  display: flex;
  justify-content: flex-end;

  .fas {
    margin-left: 10px;
  }
}

</style>
